import { Flex, useToast } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import CustomButton from "../../components/buttons/CustomButton";
import { useCreatePaymentIntent } from "../../utils/wds.api";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getLoginData, updateUser } from "../../redux/actions/auth.actions";
import PaymentForm from "../auth/components/PaymentForm";

function Payments() {
  const [searchParams] = useSearchParams();
  const paymentIntent = searchParams.get("payment_intent");

  const toast = useToast();

  const [paymentIntentInfo, setPaymentInfo] = useState<any>();
  const paymentInfo = useCreatePaymentIntent();

  const { user, uid } = useSelector((state: any) => state.authUser);
  const dispatch: any = useDispatch();
  const navigate = useNavigate();

  if (user && user?.status !== "APPROVED") {
    navigate("/dashboard");
  } else if (user && user?.isPaymentCompleted) {
    navigate("/dashboard");
  }

  useEffect(() => {
    if (!user) {
      dispatch(getLoginData(uid));
    }
  }, [dispatch, uid, user]);

  const handleUpdateUser = async () => {
    dispatch(updateUser(uid, { isPaymentCompleted: true }));
  };

  useEffect(() => {
    if (paymentIntent) {
      handleUpdateUser();
    }
    // eslint-disable-next-line
  }, [paymentIntent]);

  return (
    <div>
      <Flex justify="center">
        {!paymentIntentInfo && (
          <CustomButton
            btnTitle="Generate Payment Form"
            isLoading={paymentInfo?.isPending}
            onClick={() => {
              paymentInfo
                ?.mutateAsync({
                  amount: 1000,
                  email: user?.email,
                })
                .then((result) => {
                  setPaymentInfo(result);

                  return;
                })
                .catch((err) => {
                  toast({
                    description: err?.message,
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                  });
                });
            }}
            // bg="yess.secondary_gold"
            maxW="200px"
          />
        )}
      </Flex>
      {paymentIntentInfo && (
        <PaymentForm paymentIntent={paymentIntentInfo?.client_secret} />
      )}
    </div>
  );
}

export default Payments;
